import {
	AppBar,
	makeStyles, Toolbar
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import SvgLogoWhite from '../../resources/icons/SvgLogoWhite';

//TODO clean styles
const useStyles = makeStyles(({
	root: {},
	toolbar: {
		height: 64
	}
}));

// TODO add a global progress bar using extended kea logic
const TopBar = ({ className, ...rest }) => {
	const classes = useStyles();

	return (
		<AppBar
			className={clsx(classes.root, className)}
			elevation={0}
			{...rest}
		>
			<Toolbar className={classes.toolbar}>
				<RouterLink to="/">
					<SvgLogoWhite />
				</RouterLink>
			</Toolbar>
		</AppBar>
	);
};

TopBar.propTypes = {
	className: PropTypes.string
};

export default TopBar;
